var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssueDirty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "m9.317 6.383 3.504-2.47c.474-.334.588-.994.254-1.468a1.054 1.054 0 0 0-1.466-.253l-3.505 2.47A1.054 1.054 0 0 0 7.85 6.13c.333.474.993.588 1.467.254zm10.039.434-2.42 3.54a1.055 1.055 0 0 1-1.463.275 1.055 1.055 0 0 1-.275-1.463l2.42-3.541a1.055 1.055 0 0 1 1.464-.275c.477.328.6.985.274 1.464zm-8.676 6.396-.23-4.282a1.056 1.056 0 0 1 .995-1.108 1.056 1.056 0 0 1 1.107.995l.23 4.282a1.056 1.056 0 0 1-.994 1.107 1.056 1.056 0 0 1-1.107-.994zm11.02.891-3.503 2.471a1.054 1.054 0 0 1-1.467-.254 1.055 1.055 0 0 1 .254-1.466l3.504-2.471a1.054 1.054 0 0 1 1.467.254c.334.473.22 1.133-.254 1.466zm-11.535 7.164 3.504-2.471c.474-.333.588-.993.254-1.467a1.055 1.055 0 0 0-1.466-.254l-3.504 2.471a1.054 1.054 0 0 0-.254 1.467c.332.474.993.588 1.466.254zm-4.377-9.371L2.816 8.805a1.055 1.055 0 0 1 .03-1.488 1.055 1.055 0 0 1 1.488.03l2.972 3.092a1.055 1.055 0 0 1-.03 1.488 1.055 1.055 0 0 1-1.488-.03zm-2.736 5.109h4.29c.578 0 1.052-.474 1.052-1.052 0-.58-.474-1.053-1.053-1.053H3.052c-.578 0-1.052.474-1.052 1.053 0 .578.474 1.052 1.052 1.052z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueDirty);
export default __webpack_public_path__ + "static/media/issue_dirty.44bf35f95f20315fc939bc1d4eba9b92.svg";
export { ForwardRef as ReactComponent };